import { render } from "./SubmitMemorialView.vue?vue&type=template&id=1111702b"
import script from "./SubmitMemorialView.vue?vue&type=script&lang=js"
export * from "./SubmitMemorialView.vue?vue&type=script&lang=js"

import "./SubmitMemorialView.vue?vue&type=style&index=0&id=1111702b&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__